var render = function (_h,_vm) {var _c=_vm._c;return _c('td',_vm._g(_vm._b({class:[
		_vm.props.variant === 'ghost'
			? _vm.data.class
			: "s-px-6 s-py-4 s-whitespace-no-wrap s-border-b s-border-gray-200 s-text-sm s-leading-5 s-font-medium s-text-gray-900",
		_vm.data.staticClass
	]},'td',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }